import { FilterFn } from '@tanstack/react-table';

export const dateBetweenFilterFn: FilterFn<any> = (row, columnId, value) => {
    let date: Date = row.getValue(columnId);
    if (!(date instanceof Date)) {
        date = new Date(date as string);
    }
    const [start, end] = value; // value => two date input values
    //If one filter defined and date is null filter it
    if ((start || end) && !date) return false;
    if (start && !end) {
        console.log(date)
        return date.getTime() >= start.getTime();
    } else if (!start && end) {
        return date.getTime() <= end.getTime();
    } else if (start && end) {
        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
    } else return true;
};

dateBetweenFilterFn.autoRemove = (value) => !value || value.length === 0;

export default dateBetweenFilterFn;
